module.exports = __webpack_public_path__ + "media/assets/SuccessAlert-1730e425f7100a26aea9d4848edac68b.svg";